'use client';

import Script from 'next/script';
import { PropsWithChildren } from 'react';

import { HotjarPromoScript } from '@/components/3rdParty/HotjarPromoScript';
import { CLIENT_ENVS } from '@/helpers/constants';
import { work_sans } from '@/theme/fonts';

import StyledComponentsRegistry from '@/styles/registry';

const { GA_MEASUREMENT_ID, GTM_ID } = CLIENT_ENVS;

interface IRootLayout extends PropsWithChildren {
  params: { locale: string };
}

export default function RootLayout({
  children,
  params: { locale },
}: IRootLayout) {
  return (
    <html lang={locale}>
      <head>
        {/* GA */}
        {GA_MEASUREMENT_ID && (
          <>
            <Script
              strategy="afterInteractive"
              src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
            />
            <Script
              id="google-analytics"
              strategy="afterInteractive"
              dangerouslySetInnerHTML={{
                __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${GA_MEASUREMENT_ID}', { page_path: window.location.pathname, hostname: window.location.hostname });
            `,
              }}
            />
          </>
        )}

        {/* GTM */}
        {GTM_ID && (
          <Script
            id="gtm-script"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
              __html: `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${GTM_ID}');
            `,
            }}
          />
        )}
      </head>
      <body className={work_sans.className}>
        {
          /* GTM */
          GTM_ID && (
            <noscript
              dangerouslySetInnerHTML={{
                __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}"
                    height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
              }}
            />
          )
        }

        <StyledComponentsRegistry>{children}</StyledComponentsRegistry>
        <HotjarPromoScript />
      </body>
    </html>
  );
}
